import React, { useState, useEffect, useRef } from "react";

import {
    Container,
    Dialog,
    Button,
    DialogContent,
    DialogActions,
    Divider,
    Grid,
    TextField,
    Switch,
    Select,
    MenuItem,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { statusEnum } from "../../../config/status";
import { categoryEnum } from "../../../config/category";
import { gradeEnum } from "../../../config/grade";
import tableIcons from "../../../config/tableIcons";
import InputMask from "react-input-mask";

import List from "../../../components/List";
import Label from "../../../components/Label";
import Description from "../../../components/Description";
import EventApi from "../../../services/event";

import { ContainerBox, Align, Content } from "./styles";
import { config } from "../../../config";
import CreateGuest from "./CreateGuest";

import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import usePersonData from "../../../hooks/usePersonData";
import Credential from "../../../components/Credential";
import { eventRoles } from "../../../utils/Enums";
import { getFirstAndLastNames } from "../../../utils/Functions";
import { settings } from "../../../config/eventSettings";
import Loading from "../../../components/Loading";

const Invites = (props) => {
    const { updateCredential } = usePersonData();
    const [invites, setInvites] = useState([]);
    const [statusNames, setStatus] = useState([]);
    const [categoryNames, setCategory] = useState([]);
    const [statusValues, setStatusValues] = useState({});
    const [categoryValues, setCategoryValues] = useState({});
    const [gradeNames, setGrade] = useState([]);
    const [gradeValues, setGradeValues] = useState({});
    const [person, setPerson] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogDelete, setDialogDelete] = useState(false);
    const [createGuestOpen, setCreateGuestOpen] = useState(false);
    const [dialogSendMail, setDialogSendMail] = useState(false);
    const columns = settings.fields;

    const [totalShowed, setTotalShowed] = useState(0);
    const [totalPeople, setTotalPeople] = useState(0);
    const [totalCredentiated, setTotalCredentiated] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const actions = [
        {
            icon: tableIcons.Edit,
            tooltip: "Editar convidado",
            onClick: (e, request) => {
                setPerson({ ...request, name_tag: request?.name_tag ? request?.name_tag : request?.name });
                setDialogOpen({ dialogOpen: true });
            },
        },
        {
            icon: tableIcons.Delete,
            tooltip: "Deletar convidado",
            onClick: (e, request) => {
                setPerson({ ...request });
                setDialogDelete({ dialogDelete: true });
            },
        },
        // {
        //     icon: tableIcons.Mail,
        //     tooltip: "Reenviar confirmação",
        //     onClick: (e, request) => {
        //         setPerson({ ...request });
        //         handleOpenSendMail();
        //     },
        // },
    ];

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }
    const handleChange = (event) => {
        const { checked, name } = event.target;
        setPerson({ ...person, [name]: checked });
    };
    const handleSelect = (event, valuesList, keyName1, keyName2) => {
        const { value } = event.target;
        Object.keys(valuesList).forEach((key) => {
            if (valuesList[key].name === value) {
                setPerson({
                    ...person,
                    [keyName1]: parseInt(key, 10),
                    [keyName2]: value,
                });
            }
        });
    };

    const handleSelectRole = (event) => {
        const { value } = event.target;
        setPerson({
            ...person,
            event_category: value,
        });
    };

    const handleOpen = () => {
        setDialogOpen(true);
    };
    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleOpenDelete = () => {
        setDialogDelete(true);
    };
    const handleCloseDelete = () => {
        setDialogDelete(false);
    };

    const handleOpenCreateGuest = () => {
        setCreateGuestOpen(true);
    };
    const handleCloseCreateGuest = () => {
        setCreateGuestOpen(false);
    };

    const handleOpenSendMail = () => {
        setDialogSendMail(true);
    };
    const handleCloseSendMail = () => {
        setDialogSendMail(false);
    };

    const isValidForm = () => {
        let isValid = true;
        const errors = [];
        Object.entries(person).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            // if (key === "email") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira um endereço de email");
            //     }
            // }
            // if (key === "category") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Selecione uma categoria");
            //     }
            // }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        return {
            ...person,
            certificate: person?.certificate ? 1 : 0,
            cpf: person?.cpf ? person.cpf.match(/\d/g).join("") : null,
            phone: person?.phone ? person.phone.match(/\d/g).join("") : null,
            extra_people: person?.extra_people || [],
            email: person?.email?.toLowerCase(),
            event_days_subscribed: person?.event_days_subscribed || ["*"],
            event_days_attended: person?.event_days_attended ? person?.event_days_attended : ["*"],
        };
    };

    const updatePerson = () => {
        if (!isValidForm()) return;
        const personToUpdate = formatData();
        EventApi.updatePerson(person.id, personToUpdate)
            .then((resp) => {
                if (!!resp.data) {
                    toast.success("usuário alterado com sucesso!");
                    handleClose();
                    window.location.reload();
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };

    const deletePerson = () => {
        EventApi.deletePerson(person.id)
            .then((resp) => {
                if (resp) {
                    console.log(resp.data);
                    toast.success("usuário deletado com sucesso!");
                }
                handleCloseDelete();
                window.location.reload();
            })
            .catch(function (error) {
                toast.error(error);
                handleCloseDelete();
            });
    };

    const sendMail = () => {
        EventApi.sendNewMail({
            qrcode: `${config.QRCODE_HOST}?size=200x200&data=${person.id}`,
            name: person.name,
            email: person.email,
        })
            .then((resp) => {
                if (resp) {
                    toast.success("Email enviado com sucesso!");
                }
                handleCloseSendMail();
            })
            .catch(function (error) {
                toast.error(error);
                handleCloseSendMail();
            });
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        // pageStyle: `
        //     @page { size: 100mm 50mm; margin: 0; }
        //     body { margin: 0; }
        //     .tag {
        //         width: 100mm;
        //         height: 50mm;
        //         display: flex;
        //         align-items: center;
        //         justify-content: center;
        //         box-sizing: border-box;
        //         page-break-inside: avoid;
        //     }
        // `,
    });

    const handleDownload = async () => {
        try {
            const sticker = document.getElementById("to_pdf");
            if (!person) throw new Error("Ocorreu um erro ao pegar dados do participante");
            if (!sticker) throw new Error("Ocorreu um erro ao pegar info da credencial");

            toast.info("Gerando arquivo");

            await html2pdf()
                .set({
                    margin: 2,
                    filename: `${person.name.replace(/\s/g, "_")}.pdf`,
                    image: { quality: 1 },
                    html2canvas: { scale: 2, useCORS: true },
                    pagebreak: { mode: "avoid-all" },
                    jsPDF: { format: [340, 151] },
                })
                .from(sticker)
                .save();

            toast.success("Download em execução");
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const handleUpdateCredential = async () => {
        setIsLoading(true);
        await updateCredential(person.id, 1);
        setIsLoading(false);
    };

    const getRows = async () => {
        try {
            setIsLoading(true);

            const [respEvent, statusResp, catResp, gradeResp] = await Promise.all([
                EventApi.getAllPersonByEvent(props.data.id, {}),
                EventApi.getStatus(),
                EventApi.getCategory(),
                EventApi.getGrade(),
            ]);

            if (!respEvent || !statusResp.data || !catResp.data || !gradeResp.data) {
                throw new Error("Failed to load data");
            }

            const status = Object.fromEntries(statusResp.data.data.map((item) => [item.id, item]));
            const category = Object.fromEntries(catResp.data.data.map((item) => [item.id, item]));
            const grade = Object.fromEntries(gradeResp.data.data.map((item) => [item.id, item]));

            setStatus(Object.values(status).map((item) => item.name));
            setStatusValues(status);
            setCategory(Object.values(category).map((item) => item.name));
            setCategoryValues(category);
            setGrade(Object.values(grade).map((item) => item.name));
            setGradeValues(grade);

            const totalPeople = respEvent.data.data.length;
            let totalShowedUp = 0;
            let totalCredentials = 0;

            const formatedList = respEvent.data.data.map((item) => {
                const isCredenciated = item.credential_generated;
                if (item.status_id === 5) totalShowedUp++;
                if (isCredenciated) totalCredentials++;

                return {
                    ...item,
                    status: status[item.status_id]?.name || "",
                    statusName: statusEnum[status[item.status_id]?.name] || "",
                    category: item.category_id ? category[item.category_id]?.name || "" : "",
                    categoryName: item.category_id ? categoryEnum[category[item.category_id]?.name] || "" : "",
                    grade: item.grade_id ? grade[item.grade_id]?.name || "" : "",
                    gradeName: item.grade_id ? gradeEnum[grade[item.grade_id].name] || "" : "",
                    positionValue: item.position?.value || "",
                    isVip: item.vip ? "Sim" : "Não",
                    created: new Date(item.createdAt).toLocaleDateString(),
                    isCredenciated: isCredenciated ? "Sim" : "Não",
                };
            });

            setTotalPeople(totalPeople);
            setTotalShowed(totalShowedUp);
            setTotalCredentiated(totalCredentials);
            setIsLoading(false);

            return { rows: formatedList, total: respEvent.data.total };
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Erro ao carregar os dados");
            setIsLoading(false);
            return { rows: [], total: 0 };
        }
    };

    const deleteDialog = (
        <>
            <Dialog onClose={handleCloseDelete} open={dialogDelete}>
                <ContainerBox className="content">
                    <DialogContent>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Deletar Usuário
                        </Label>
                        <Label size="nano" color="black" align="left">
                            Tem certeza que deseja deletar o usuário <b>{person.name}</b>?
                        </Label>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDelete} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={deletePerson} color="primary">
                            Deletar Usuário
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const sendMailDialog = (
        <>
            <Dialog onClose={handleCloseSendMail} open={dialogSendMail}>
                <ContainerBox className="content">
                    <DialogContent>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Reenviar Confirmação
                        </Label>
                        <Label size="nano" color="black" align="left">
                            Tem certeza que deseja reenviar o email de confirmação para <b>{person.name}</b>?
                        </Label>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSendMail} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={sendMail} color="primary">
                            Enviar
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const modal = (
        <Dialog fullWidth onClose={handleCloseCreateGuest} open={createGuestOpen}>
            <ContainerBox className="content">
                <CreateGuest
                    handleClose={handleCloseCreateGuest}
                    categoryNames={categoryNames}
                    categoryValues={categoryValues}
                    gradeNames={gradeNames}
                    gradeValues={gradeValues}
                    eventData={props.data}
                />
            </ContainerBox>
        </Dialog>
    );

    const editDialog = (
        <>
            <Dialog onClose={handleClose} open={dialogOpen}>
                <ContainerBox className="content">
                    <DialogContent>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Detalhes do convidado
                        </Label>
                        <Description name="id:" value={person.id} />
                        {/* <Description name="cpf:" value={person.cpf} /> */}
                        <Divider />
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <TextField
                                    key="nome"
                                    name="name"
                                    required
                                    label="Nome do convidado"
                                    onChange={onChange}
                                    value={person.name}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="name_tag"
                                    name="name_tag"
                                    label="Nome Etiqueta"
                                    onChange={onChange}
                                    value={person.name_tag}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="email"
                                    name="email"
                                    label="Email para contato"
                                    onChange={onChange}
                                    value={person.email}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="cpf"
                                    name="cpf"
                                    label="Documento"
                                    onChange={onChange}
                                    value={person.cpf}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <TextField
                                    key="company"
                                    name="company"
                                    label="Empresa"
                                    onChange={onChange}
                                    value={person.company}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="role"
                                    name="role"
                                    label="Cargo"
                                    onChange={onChange}
                                    value={person.role}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <InputMask
                                    mask="+55 (99) 9 9999-9999"
                                    value={person.phone}
                                    onChange={onChange}
                                    disabled={false}
                                    maskChar=""
                                    type="text"
                                    name="phone"
                                >
                                    {() => (
                                        <TextField
                                            key="phone"
                                            name="phone"
                                            label="Telefone para contato"
                                            fullWidth
                                            value={person.phone}
                                            onChange={onChange}
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            {/* <Grid item md={6}>
                                <label>Status:</label>
                                <Select
                                    label="Status"
                                    name="status"
                                    fullWidth
                                    value={person.status}
                                    onChange={(e) => handleSelect(e, statusValues, "status_id", "status")}
                                >
                                    {statusNames.map((item) => {
                                        return <MenuItem value={item}>{statusEnum[item]}</MenuItem>;
                                    })}
                                </Select>
                            </Grid> */}
                            <Grid item md={12}>
                                <label>Categoria:</label>
                                <Select
                                    placeholder="Categoria"
                                    label="Categoria"
                                    name="event_category"
                                    fullWidth
                                    value={person.event_category}
                                    onChange={(e) => handleSelectRole(e)}
                                >
                                    {eventRoles.map((item) => {
                                        return <MenuItem value={item}>{item}</MenuItem>;
                                    })}
                                </Select>
                                {/* <Align>
                                    <Switch checked={person.vip} onChange={handleChange} name="vip" />
                                    <Label>vip</Label>
                                </Align>
                                <Align>
                                    <Switch checked={person.certificate} onChange={handleChange} name="certificate" />
                                    <Label>certificado</Label>
                                </Align> */}
                            </Grid>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    // style={{ width: "240px", height: "120px", border: "none" }}
                                    style={{ width: "340px", height: "189px", border: "none" }}
                                >
                                    <Credential
                                        id={person.id}
                                        name={person?.name_tag ? person.name_tag : getFirstAndLastNames(person.name)}
                                        company={person.company}
                                        // role={person.role}
                                        qrcode={false}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                handlePrint();
                                await handleUpdateCredential();
                            }}
                            color="default"
                        >
                            imprimir
                        </Button>
                        <Button variant="contained" onClick={handleDownload} color="default">
                            gerar pdf
                        </Button>
                        <Button onClick={handleClose} color="secondary">
                            cancelar
                        </Button>
                        <Button onClick={updatePerson} color="primary">
                            salvar dados
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    return (
        <ContainerBox>
            {isLoading && <Loading />}

            {deleteDialog}
            {editDialog}
            {modal}
            {sendMailDialog}
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                    padding: "2px",
                }}
            >
                {/* {totalShowed ? (
                    <div style={{ padding: "2px" }}>
                        <h2>
                            Compareceram: {totalShowed} / {totalPeople}
                        </h2>
                    </div>
                ) : null}
                {totalCredentiated ? (
                    <div style={{ padding: "2px" }}>
                        <h2>Total Credenciados: {totalCredentiated}</h2>
                    </div>
                ) : null} */}

                <Button
                    size="nano"
                    variant="contained"
                    color="primary"
                    format="solid"
                    width="100%"
                    onClick={handleOpenCreateGuest}
                >
                    Novo Convidado
                </Button>
            </div>
            <Content>
                <List columns={columns} rows={[]} getRows={getRows} actions={actions} />
            </Content>
        </ContainerBox>
    );
};

export default Invites;
